/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const explain_share_body = () => `Want to share a ticket with a friend? It takes a few clicks. You can hand the ticket over straight away, or have them pay for it first — that amount is then transferred back to you automatically. No more chasing people for the money.`
